import { render, staticRenderFns } from "./PaymentTypeWindow.vue?vue&type=template&id=6aa74637&scoped=true&"
import script from "./PaymentTypeWindow.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeWindow.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeWindow.vue?vue&type=style&index=0&id=6aa74637&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa74637",
  null
  
)

export default component.exports